import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({
  mode: 'white',
  toggle: () => {},
});

export const useTheme = () => useContext(ThemeContext);

const STORAGE_KEY = 'theme-mode';

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState('white');

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'dark' || saved === 'white') {
        setMode(saved);
    } else if (!saved) {
        setMode('dark');     
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, mode);
    if (mode === 'white')
        document.body.id = mode;
    else
        document.body.removeAttribute("id");
  }, [mode]);

  const toggle = () => {
    setMode(prev => (prev === 'white' ? 'dark' : 'white'));
  };

  return (
    <ThemeContext.Provider value={{ mode, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
};
